import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { parseISO } from 'date-fns';
import { isNumber as _isNumber } from 'lodash';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function toDate(dateVal?: string | Date) {
  if (!dateVal) {
    return new Date();
  }
  if (typeof dateVal === 'string') {
    let datePart: string;
    let timePart = '';
    if (dateVal.indexOf('T') > 0) {
      return parseISO(dateVal);
    } else {
      const parts = dateVal.split(' ');
      if (parts.length > 1) {
        datePart = parts[0];
        timePart = parts[1];
      } else {
        datePart = dateVal;
      }
    }

    let d = datePart ? datePart.split('-') : [];
    let t = timePart ? timePart.split(':') : [];
    if (d.length === 3 && t.length >= 3) {
      return new Date(
        parseInt(d[0]),
        parseInt(d[1]) - 1,
        parseInt(d[2]),
        parseInt(t[0]),
        parseInt(t[1]),
        parseInt(t[2].split('.')[0]),
      );
    } else if (d.length === 3) {
      return new Date(parseInt(d[0]), parseInt(d[1]) - 1, parseInt(d[2]));
    }
  }
  return dateVal instanceof Date ? dateVal : new Date(dateVal);
}

export const isEmpty = (obj: any, zeroEmpty: boolean = false) => {
  if (typeof obj === 'undefined') {
    return true;
  }
  if (obj === null) {
    return true;
  }
  if (typeof zeroEmpty !== 'undefined' && zeroEmpty) {
    if (typeof obj === 'number') return obj === 0;
    if (typeof obj === 'string') return obj === '' || obj === '0';
  } else {
    if (typeof obj === 'string') return obj === '';
    if (typeof obj === 'number') return isNaN(obj);
  }
  if (obj instanceof Date) {
    const now = new Date();
    return obj === now;
  }
  if (typeof obj === 'object') {
    if (obj.length && obj.length === 0) {
      return true;
    }
    return obj && Object.keys(obj).length === 0;
  }
  return false;
};

export function toNumber(val: any): number {
  if (isNumber(val)) {
    val = parseFloat(val);
  } else if (typeof val === 'string') {
    val = parseFloat(val.replace(/[^0-9.-]/g, ''));
  }
  if (isNaN(val)) val = 0;
  return val;
}

export function isNumber(val: any): boolean {
  return !isNaN(val);
}

export function isNumeric(value: any) {
  if (typeof value === 'string') {
    return !isNaN(Number(value));
  }
  return _isNumber(value);
}

export function uniqueId(prefix = '') {
  return prefix + Math.random().toString(36).substring(2, 11);
}